/**
 * Maintenance Mode Banner
 * Displays a warning banner when REACT_APP_MAINTENANCE_MESSAGE is set.
 * Dismissible per session via sessionStorage.
 */

import React, { useState, useEffect } from 'react';
import './MaintenanceBanner.css';

const MaintenanceBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  const message = process.env.REACT_APP_MAINTENANCE_MESSAGE;

  useEffect(() => {
    if (sessionStorage.getItem('maintenance_banner_dismissed') === 'true') {
      setDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('maintenance_banner_dismissed', 'true');
  };

  if (!message || dismissed) return null;

  return (
    <div className="maintenance-banner" role="alert">
      <div className="maintenance-banner-content">
        <span className="maintenance-banner-icon">{'\u26A0'}</span>
        <span className="maintenance-banner-text">
          <strong>Scheduled Maintenance:</strong> {message}
        </span>
        <button
          className="maintenance-banner-dismiss"
          onClick={handleDismiss}
          title="Dismiss"
          aria-label="Dismiss maintenance notice"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
